var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { MarketingBanner } from "core/components";
import { mq } from "core/styles/snippets";
import * as Option from "fp-ts/lib/Option";
import React from "react";
import styled from "styled-components";
import { dataToProgramBannerData } from "./bannersUtils";
function isBannerCompatible(home, field) {
    return field === "banner1" && home.banner1 !== null;
}
function isBanner2Compatible(home, field) {
    return field === "banner2" && home.banner2 !== null;
}
function isBanner3Compatible(home, field) {
    return field === "banner3" && home.banner3 !== null;
}
export var block = function (field) {
    return function (data) {
        if (field === "plusBanner") {
            var defaultPlusBanner = {
                __typename: "DefaultVtmGoPlus",
                bannerType: "DEFAULT_VTM_GO_PLUS",
                uuid: "default-vtmgo-plus",
            };
            return getBlock(defaultPlusBanner, data.fetchingData);
        }
        if (isBannerCompatible(data, field) && field === "banner1") {
            return getBlock(data.banner1, data.fetchingData);
        }
        if (isBanner2Compatible(data, field) && field === "banner2") {
            return getBlock(data.banner2, data.fetchingData);
        }
        if (isBanner3Compatible(data, field) && field === "banner3") {
            return getBlock(data.banner3, data.fetchingData);
        }
        return Option.none;
    };
};
function getBlock(data, fetchingData) {
    return Option.some({
        key: data.uuid,
        View: function () {
            return (React.createElement(Wrapper, null,
                React.createElement(MarketingBanner, { banner: dataToProgramBannerData(data), trackingEnabled: !fetchingData })));
        },
    });
}
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 120rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n\n  ", " {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  ", " {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  ", " {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n"], ["\n  width: 100%;\n  max-width: 120rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n\n  ", " {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  ", " {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  ", " {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n"])), mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"));
var templateObject_1;
